import $ from 'jquery';
window.$ = window.jQuery = $;

export function navigInit(){
    jQuery(document).ready(function ( $ ){
        $("button.hamburger").on("click", function(){
          $(this).toggleClass("is-active");
          if($("#header-menu-collapse").height() > 0){
            $("#header-menu-collapse").animate({height: '0px'});
            $(".navig").css('background-color', 'rgba(0,0,0,.8)');
            $("body").css('overflow', 'auto');
            $(".navig__title span").css('color','#fff');
          } else{
            $("#header-menu-collapse").animate({height: '100vh'});
            $(".navig").css('background-color', 'rgba(0,0,0,.95)');
            $("body").css('overflow', 'hidden');
            $(".navig__title span").css('color','#008404');
          }
          if(window.matchMedia('(max-width: 768px)').matches) $(".navig__title").slideToggle();
          $("#header-menu-collapse ul").slideToggle();
        });
    });
}